import React, { useEffect, useState } from 'react';
import { PhoneIcon, MenuIcon, XIcon } from 'lucide-react';
import { Link } from 'react-scroll';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navItems = ['Home', 'About', 'Services', 'Portfolio', 'AI Assistant', 'Blog', 'Contact'];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0a1628]/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`} data-id="element-160">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-161">
        <div className="flex items-center justify-between h-16 sm:h-20" data-id="element-162">
          {/* Logo */}
          <div className="flex-shrink-0" data-id="element-163">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dAYYfeDuWyKwcT5CAP4nPa/Untitled_Design_683x743.png" alt="Renova8 & Build" className="h-12 sm:h-14 w-auto" data-id="element-164" />
          </div>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6 lg:space-x-8" data-id="element-165">
            {navItems.map(item => <Link key={item} to={item.toLowerCase().replace(' ', '-')} spy={true} smooth={true} duration={500} className="text-white hover:text-[#d4af37] transition-colors cursor-pointer text-sm font-medium" data-id="element-166">
                {item}
              </Link>)}
          </nav>
          {/* Phone Button */}
          <a href="tel:+61721004589" className="hidden md:flex items-center gap-2 bg-[#d4af37] text-[#0a1628] px-4 lg:px-6 py-2.5 lg:py-3 rounded-full font-semibold hover:shadow-lg hover:shadow-[#d4af37]/50 transition-all duration-300 transform hover:scale-105 text-sm border border-[#d4af37]" data-id="element-167">
            <PhoneIcon className="w-4 h-4" data-id="element-168" />
            +61 7 2100 4589
          </a>
          {/* Mobile Menu Button */}
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden text-white" data-id="element-169">
            {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-170" /> : <MenuIcon className="w-6 h-6" data-id="element-171" />}
          </button>
        </div>
        {/* Mobile Menu */}
        {isMobileMenuOpen && <div className="md:hidden py-4 space-y-4" data-id="element-172">
            {navItems.map(item => <Link key={item} to={item.toLowerCase().replace(' ', '-')} spy={true} smooth={true} duration={500} onClick={() => setIsMobileMenuOpen(false)} className="block text-white hover:text-[#d4af37] transition-colors cursor-pointer py-2" data-id="element-173">
                {item}
              </Link>)}
            <a href="tel:+61721004589" className="flex items-center gap-2 bg-[#d4af37] text-[#0a1628] px-6 py-3 rounded-full font-semibold justify-center border border-[#d4af37]" data-id="element-174">
              <PhoneIcon className="w-4 h-4" data-id="element-175" />
              +61 7 2100 4589
            </a>
          </div>}
      </div>
    </header>;
}